import { getBaseUrl } from '../apollo/client';
import { getAuthorizationHeader } from './index';
import { GhostPartner } from './partnerUser';

/**
 * Super admin ghosting as a partner: ask the backend for the ghosted account's
 * widget state via the Cognito session instead of a partner token.
 * Returns the same payload as /v4/auth/<partner>-login.
 */
export const fetchPartnerGhostLogin = async (partner: GhostPartner) => {
  const response = await fetch(
    `${getBaseUrl()}/v4/auth/partner-login/ghost/${partner}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'ti-id-token': getAuthorizationHeader(),
        'ti-ghosted-user':
          sessionStorage.getItem('trueimpact.ghostedUsername') ?? '',
      },
    },
  );
  if (!response.ok) throw new Error(`Error ${response.status}`);
  const data = await response.json();
  // Backend may resolve to the partner twin user (<partner>_<email>); keep
  // ghosting that user so the rest of the app matches the widget.
  if (data?.email) {
    sessionStorage.setItem('trueimpact.ghostedUsername', data.email);
  }
  return data;
};
